module.exports = __webpack_public_path__ + "static/media/in_the_can.b7e343c0.png";